import React, { FC, useEffect } from 'react'
import { observer } from 'mobx-react'
import { activityMobx, decorationMobx } from '@mobxStore'
import { useHistoryNew } from '@utils'
import { find } from '@dt/fe-utils/dist/lodash'
import './index.scss'

import luckyImg from '@img/member/lucky.png'

interface IProps { }

const LotteryAct: FC<IProps> = (props: IProps) => {
  const history = useHistoryNew()
  const { getLuckyActive, lotteryList } = activityMobx
  const { mktDecorates } = decorationMobx
  let info: any = find(mktDecorates.market, (item: any) => item.key === 'luckyDraw')
  if (!info) {
    info = find(mktDecorates.notMarket, (item: any) => item.key === 'luckyDraw') || {}
  }
  const handleGo = () => {
    history.push(lotteryList.length === 1 ? `/luckyDraw/detail/${lotteryList[0].activityId}` : '/luckyDraw')
  }
  useEffect(() => {
    if (lotteryList.length === 0) {
      getLuckyActive()
    }
  }, [])
  if (lotteryList.length === 0) return <></>
  return (
    <div data-cypid='mmgToLuckDraw' className='lottery-panel' onClick={(e: any) => handleGo()}>
      {
        !info.hideTitle &&
          <div className='lottery-panel-block' style={{ color: info.titleColor || '#161616' }}>
            <div className='title'>{i18n.t('pageName.activeList')}</div>
          </div>
      }
      <img src={info.img || luckyImg} alt='' />
    </div>
  )
}

export default observer(LotteryAct)
